export default __webpack_public_path__ + "static/media/Boxing_03.418c37e3.png";